/**
 * Service pour gérer les valeurs de réinitialisation spécifiques à Contact Manager
 */
import moment from 'moment'

/**
 * Détermine si un template est un template Contact Manager
 * @param {string} templateCode - Code du template
 * @returns {boolean}
 */
export function isContactManagerTemplate(templateCode) {
  if (!templateCode) return false
  
  return (
    templateCode.startsWith('contacts_') ||
    templateCode.startsWith('detail_contacts_') ||
    templateCode.startsWith('synthese_contacts_')
  )
}

/**
 * Récupère les valeurs de réinitialisation pour Contact Manager
 * Pour Contact Manager, on force toujours les 7 derniers jours lors de la réinitialisation
 * 
 * @param {string} templateCode - Code du template
 * @returns {Object|null} - Objet avec beforeContacts/afterContacts ou null si pas Contact Manager
 */
export function getContactManagerResetValues(templateCode) {
  if (!isContactManagerTemplate(templateCode)) {
    return null
  }

  return {
    beforeContacts: moment().subtract(7, 'days').format('YYYY-MM-DD'),
    afterContacts: moment().format('YYYY-MM-DD')
  }
}
